import React from 'react';
import { Container, Box, Typography, Chip } from '@mui/material';
import { styled } from '@mui/material/styles';
import InternRegistrationForm from '../components/InternRegistrationForm';
import photos from '../data/photos';
import SEO from '../components/common/SEO';

const HeroSection = styled(Box)({
  backgroundImage: `linear-gradient(rgba(30,58,138,0.82), rgba(124,58,237,0.82)), url("${photos.heroes.careers}")`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  color: 'white',
  padding: '64px 0',
  textAlign: 'center',
});

function ApplyPage() {
  return (
    <Box>
      <SEO title="Apply as Intern" description="Apply to join Cyber Wise Corp as a cybersecurity intern. Earn $140 per assessment." />
      <HeroSection>
        <Container maxWidth="lg">
          <Chip label="Start Your Career" sx={{ mb: 3, backgroundColor: 'rgba(255,255,255,0.15)', color: 'white' }} />
          <Typography variant="h2" component="h1" gutterBottom sx={{ fontWeight: 700 }}>
            Apply to Join CWC
          </Typography>
          <Typography variant="h5" sx={{ opacity: 0.95, maxWidth: 700, mx: 'auto' }}>
            Earn $140 per assessment. Get mentored by CISSP-certified experts. Build the career you want.
          </Typography>
        </Container>
      </HeroSection>

      <Container maxWidth="md" sx={{ py: 6 }}>
        <InternRegistrationForm onSuccess={() => window.scrollTo(0, 0)} />
      </Container>
    </Box>
  );
}

export default ApplyPage;
